import React from "react";
import {templateStrings} from "../../../Constant";
export const DeviceDelayHeader = (rest)=> {
    return (
        <span
            className="in-middle">{templateStrings.overAllDelay}({rest.timeParse})</span>)

};